import axios, { AxiosError } from 'axios'

import errorLogging from 'services/error-logging'

const EMAIL_OF_THE_DAY = process.env.EMAIL_OF_THE_DAY

const request = axios.create({
  baseURL: EMAIL_OF_THE_DAY,
  headers: {
    'Content-Type': 'application/json',
  },
})

export default {
  submit(email: string) {
    return request.post('', { email }).catch((error: AxiosError) => {
      errorLogging(new Error('error submitting email of the day signup'), {
        error,
      })
      throw error
    })
  },
}
